// extracted by mini-css-extract-plugin
export default {"listStyle":"eula_listStyle__JpVH8","eulaContainer":"eula_eulaContainer__9akJs"};